import { PromptTabs } from "@1js/pl-card-components";
import { useEffect, useState } from "react";
import { useFlightContext } from "../../../hooks/useFlightContext";

const usePageSize = (tabName: PromptTabs, defaultSize: number) => {
  const [pageSize, setPageSize] = useState(defaultSize);
  const { isFlightActive } = useFlightContext();

  useEffect(() => {
    if (!isFlightActive("isResponsiveDimensionsEnabled")) {
      setPageSize(defaultSize);
      return;
    }

    const mediaQueries = [
      window.matchMedia("(max-width: 2608px) and (min-width: 1960px)"),
      window.matchMedia("(max-width: 1960px) and (min-width: 1624px)"),
      window.matchMedia("(max-width: 1084px) and (min-width: 972px)"),
      window.matchMedia("(min-width: 2608px)"),
    ];

    const getPageSize = () => {
      if (tabName === PromptTabs.SavedPrompts) {
        if (mediaQueries[0].matches) return "12";
        if (mediaQueries[1].matches) return "10";
        if (mediaQueries[2].matches) return "9";
        if (mediaQueries[3].matches) return "16";
        return "8";
      } else {
        if (mediaQueries[0].matches) return "12";
        if (mediaQueries[1].matches) return "15";
        if (mediaQueries[2].matches) return "15";
        return "16";
      }
    };

    const updatePageSize = () => {
      const newPageSize = getPageSize();
      document.documentElement.style.setProperty("--page-size", newPageSize);
      setPageSize(parseInt(newPageSize, 10));
    };

    updatePageSize();

    mediaQueries.forEach((mq) => mq.addEventListener("change", updatePageSize));

    return () => {
      mediaQueries.forEach((mq) =>
        mq.removeEventListener("change", updatePageSize)
      );
    };
  }, []);

  return pageSize;
};

export default usePageSize;
